import React, { useState } from 'react';
const Quize = (props) => {
const {quiz} = props
const {question , option1, option2,option3,option4,answer , id } =quiz
const [selected , SetSelected] = useState()
const [correct , Setcorrect ] = useState()
const choose =(option) => {
          Setcorrect(answer)
          SetSelected(option)
}
          return (
                    <div className='h-auto '>
                             <div className="question  h-[90px] p-2">
                                       <h2 className='text-xl'> <span>Question {id}: </span> {question} </h2>
                             </div>
                             <div className='options'> 
                                        <div onClick={()=>choose('A')} className="option1 h-[50px] active:bg-blue-400  my-2 flex items-center bg-indigo-50 hover:bg-gray-200 rounded-lg pl-2  "><span className='text-xl font-bold mr-4'>A)</span>  {option1}</div>
                                        <div onClick={()=>choose('B')} className="option1 h-[50px] active:bg-blue-400  my-2 flex items-center bg-indigo-50 hover:bg-gray-200 rounded-lg pl-2"><span className='text-xl font-bold mr-4'>B)</span>  {option2}</div>
                                        <div onClick={()=>choose('C')} className="option1 h-[50px] active:bg-blue-400  my-2 flex items-center bg-indigo-50 hover:bg-gray-200 rounded-lg pl-2"><span className='text-xl font-bold mr-4'>C)</span> {option3}</div>
                                        <div onClick={()=>choose('D')} className="option1 h-[50px]  active:bg-blue-400 my-2 flex items-center bg-indigo-50 hover:bg-gray-200 rounded-lg pl-2"><span className='text-xl font-bold mr-4'>D)</span> {option4} </div>
                                        <div  className="  option1 h-[50px]  active:bg-blue-400 my-2 flex content-between items-center bg-indigo-50 hover:bg-gray-200 rounded-lg pl-2">
                                             <div className='w-2/4'>
                                             <span className='text-xl font-bold mr-4'>You Selected :</span> <span className='text-xl font-bold mr-4'> {selected}</span>
                                             </div>     
                                             <div className='w-2/4'>
                                             <span className='text-xl font-bold mr-4'>Answer :</span> <span className='text-xl font-bold mr-4'> {correct}</span>
                                             
                                             </div>     
                                                  
                                                  
                               </div>
                                        
                             </div>
                    </div>
          );
};

export default Quize;